import React from 'react';
import { Link } from 'react-router-dom';
import Navigation from '../components/Navigation';
import './TermsPage.css';

function TermsPage() {
  return (
    <div className="terms-page">
      <Navigation />
      <div className="terms-container">
        <h1>Terms and Conditions</h1>
        <p className="terms-updated">Last Updated: January 2025</p>

        <div className="terms-content">
          <section className="terms-section">
            <h2>1. Beta Service Agreement</h2>
            <p>
              TeeserGolf is currently in <strong>beta testing</strong>. By creating an account,
              you acknowledge and agree that this service is provided "as is" and "as available"
              without any warranties, express or implied. The service may contain bugs, errors,
              or other issues that could affect functionality.
            </p>
          </section>

          <section className="terms-section">
            <h2>2. Service Description</h2>
            <p>
              TeeserGolf provides tee time availability alerts for golf courses. Our service
              monitors golf course booking systems and notifies you when tee times matching
              your preferences become available.
            </p>
          </section>

          <section className="terms-section">
            <h2>3. Alert Notifications</h2>
            <p>
              You control your alert preferences through your account dashboard. When you
              disable an alert or set it to inactive, we will <strong>not</strong> send you
              notifications for that alert. You may enable, disable, or delete alerts at any
              time through your dashboard.
            </p>
            <p>
              We are not responsible for missed tee times, delayed notifications, or any
              booking-related issues. Tee time availability is controlled by the golf courses
              themselves, and we cannot guarantee availability even when an alert is triggered.
            </p>
          </section>

          <section className="terms-section">
            <h2>4. Account Responsibilities</h2>
            <p>
              You are responsible for maintaining the confidentiality of your account
              credentials. You agree to provide accurate information when creating your
              account and to keep your contact information up to date.
            </p>
          </section>

          <section className="terms-section">
            <h2>5. Acceptable Use</h2>
            <p>You agree not to:</p>
            <ul>
              <li>Use the service for any unlawful purpose</li>
              <li>Attempt to gain unauthorized access to our systems</li>
              <li>Interfere with or disrupt the service</li>
              <li>Create multiple accounts to circumvent any limitations</li>
              <li>Resell or redistribute the service without authorization</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2>6. No Guarantee of Service</h2>
            <p>
              As a beta service, TeeserGolf may be modified, suspended, or discontinued at
              any time without prior notice. We do not guarantee continuous, uninterrupted
              access to the service. We reserve the right to modify these terms at any time.
            </p>
          </section>

          <section className="terms-section">
            <h2>7. Limitation of Liability</h2>
            <p>
              To the maximum extent permitted by law, TeeserGolf and its operators shall not
              be liable for any indirect, incidental, special, consequential, or punitive
              damages, including but not limited to loss of profits, data, or other intangible
              losses resulting from your use of the service.
            </p>
          </section>

          <section className="terms-section">
            <h2>8. Privacy</h2>
            <p>
              We collect and store your email address and alert preferences to provide the
              service. We do not sell or share your personal information with third parties
              for marketing purposes. Your data may be used to improve the service and
              communicate important updates about your account.
            </p>
          </section>

          <section className="terms-section">
            <h2>9. Termination</h2>
            <p>
              You may delete your account at any time. We reserve the right to terminate or
              suspend your account if you violate these terms or engage in behavior that we
              determine to be harmful to the service or other users.
            </p>
          </section>

          <section className="terms-section">
            <h2>10. Contact</h2>
            <p>
              If you have questions about these terms, please contact us through the
              appropriate channels provided on our website.
            </p>
          </section>
        </div>

        <div className="terms-footer">
          <Link to="/create-account" className="back-link">
            &larr; Back to Create Account
          </Link>
        </div>
      </div>
    </div>
  );
}

export default TermsPage;
